import { getLocalStorage } from './getLocalStorage'

export default function getFinalUrl(item) {
	// early exit check
	if (!item.virtual) return item.url

	const children = item.items ?? []
	const getUrl = item => (item.virtual ? getFinalUrl(item) : item.url)

	if (item.switcherInit) {
		// try persisted page
		const subPage = getLocalStorage().getItem(item.switcherInit.uses)
		const childItem = children.find(child => child.switcherData?.id === subPage)

		// found matching child item
		if (childItem) return getUrl(childItem)

		// try picking up the default
		const defaultItem = children.find(child => child.switcherData?.id === item.switcherInit?.default)

		if (defaultItem) return getUrl(defaultItem)

		// fallback
		return item.url
	}

	for (const child of children) {
		const childUrl = getUrl(child)
		if (childUrl) return childUrl
	}

	// fallback
	return item.url
}
